import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PivotTableChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pivot_table_chart"}/>
}
